module.exports = __webpack_public_path__ + "img/circle_social media.b74faf25.svg";